import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

import Grid_1 from '~/assets/icons/GRID-1.svg?react';
import Grid_2 from '~/assets/icons/GRID-2.svg?react';
import Grid_3 from '~/assets/icons/GRID-3.svg?react';
import Grid_4 from '~/assets/icons/GRID-4.svg?react';
import Grid_5 from '~/assets/icons/GRID-5.svg?react';
import Grid_6 from '~/assets/icons/GRID-6.svg?react';
import Horizontal from '~/assets/icons/horizontal.svg?react';
import Vertical from '~/assets/icons/vertical.svg?react';
import { Text } from '~/components/ui/text';
import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

const GRID_LIST = [
  {
    title: 'other:vertical',
    component: <Vertical />,
    type: 'VERTICAL',
  },
  {
    title: 'other:horizontal',
    component: <Horizontal />,
    type: 'HORIZONTAL',
  },
  {
    title: 'other:grid',
    component: <Grid_1 />,
    type: 'GRID-1',
    translationParams: { gridId: 1 },
  },
  {
    title: 'other:grid',
    component: <Grid_2 />,
    type: 'GRID-2',
    translationParams: { gridId: 2 },
  },
  {
    title: 'other:grid',
    component: <Grid_3 />,
    type: 'GRID-3',
    translationParams: { gridId: 3 },
  },
  {
    title: 'other:grid',
    component: <Grid_4 />,
    type: 'GRID-4',
    translationParams: { gridId: 4 },
  },
  {
    title: 'other:grid',
    component: <Grid_5 />,
    type: 'GRID-5',
    translationParams: { gridId: 5 },
  },
  {
    title: 'other:grid',
    component: <Grid_6 />,
    type: 'GRID-6',
    translationParams: { gridId: 6 },
  },
];

type GridSelectorProps = {
  setImagesType?: (type: string) => void;
  className?: string;
  maxWidth?: number;
  defaultImageType: string;
};
export default function GridSelector({ setImagesType, defaultImageType, className = '', maxWidth }: GridSelectorProps) {
  const { t } = useTranslation();

  const defaultType = GRID_LIST.find((item) => item?.type === defaultImageType)?.type;
  const [selectedType, setSelectedType] = useState(defaultType || 0);

  const handleItemClick = (index, type) => {
    setSelectedType(type);
    setImagesType(type);
  };

  return (
    <StyledContainer className={className} style={{ maxWidth }}>
      {GRID_LIST.map((item, index) => {
        const isSelected = item.type === selectedType;

        return (
          <StyledItem key={item.type} onClick={() => handleItemClick(index, item.type)} $isSelected={isSelected}>
            {item.component}
            <Text variant="typographyBody2" sx={{ color: COLORS.black06, whiteSpace: 'nowrap' }}>
              {t(item.title, item.translationParams)}
            </Text>
          </StyledItem>
        );
      })}
    </StyledContainer>
  );
}

const StyledContainer = styled('div')(({ theme }) => {
  return {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    overflow: 'auto',
    scrollSnapType: 'x mandatory',
    '& > *': {
      scrollSnapAlign: 'center',
    },
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      maxWidth: 'calc(100dvw - 64px)',
    },
  };
});

const StyledItem = styled('button')(({ $isSelected }) => {
  return {
    backgroundColor: COLORS.white,
    borderRadius: '4px',
    border: `${$isSelected ? '2' : '1'}px solid ${$isSelected ? COLORS.primary : COLORS.grayE0}`,
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    minWidth: '78px',
    cursor: 'pointer',
    flex: 1,
  };
});
